/**
 * Below Tailwind `xl` (max-width 1279px): default sidebars collapsed.
 * iPad 10" in landscape is often ~1024–1180 CSS px wide — above `lg` (1024) but
 * still tablet-sized; using 1279px includes those viewports so the rail starts collapsed.
 */
export function getInitialSidebarCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 1279px)').matches;
}
